import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/openclaw'),
    name: 'openclaw_view',
    meta: {
      permissions: ['administrator'],
    },
    component: () => import('./OpenclawView.vue'),
  },
];
